import React, { useEffect, useState } from "react";
import "../style/Header.css";
import logo from "../images/logo_name.png";
import { LuMenu, LuX } from "react-icons/lu";

const navLinks = [
  { label: "Home", href: "#home" },
  { label: "Products", href: "#products" },
  { label: "About Us", href: "#about" },
  { label: "Why Rammyaa", href: "#why" },
  { label: "Contact", href: "#contact" },
];

const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`header${scrolled ? " header-scrolled" : ""}`}>
      <div className="header-inner">
        <a href="#home" className="header-logo-link">
          <img src={logo} alt="Rammyaa haircare logo" className="header-logo" />
        </a>
        <nav className="header-nav">
          {navLinks.map((link) => (
            <a key={link.label} href={link.href} className="header-nav-link">
              {link.label}
            </a>
          ))}
          <a href="#products" className="header-shop-btn">
            Shop Now
          </a>
        </nav>
        <button
          type="button"
          aria-label="Toggle menu"
          className="header-menu-btn"
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <LuX size="1.5em" /> : <LuMenu size="1.5em" />}
        </button>
      </div>
      {open && (
        <nav className="header-mobile-nav">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              className="header-nav-link"
              onClick={() => setOpen(false)}
            >
              {link.label}
            </a>
          ))}
          <a
            href="#products"
            className="header-shop-btn"
            onClick={() => setOpen(false)}
          >
            Shop Now
          </a>
        </nav>
      )}
    </header>
  );
};

export default Header;
